export default function Loading() {
    return <div className="col-span-12">Loading...</div>;
}
